import { getTestQueryKey } from "@/queries/tests/keys";
import {
  PatchTestMutationOptions,
  PatchTestMutationVariables,
} from "@/queries/tests/mutations";
import { Answer } from "@/types/test";
import { QueryClient } from "@tanstack/react-query";

export const getPatchTestMutationOptions = (
  queryClient: QueryClient,
): PatchTestMutationOptions => {
  return {
    onSuccess: (_data, variables, _context) => {
      queryClient.invalidateQueries({
        queryKey: getTestQueryKey(variables.job_opening_slug, variables.slug),
      });
    },
  };
};

export function preparePatchTestMutationData(
  jobOpeningSlug: string,
  testSlug: string,
  activeQuestionId: string | number,
  activeQuestionAnswer: Answer | undefined,
): PatchTestMutationVariables | null {
  const choosenOptions = activeQuestionAnswer?.chosenOptions.map((option) =>
    Number(option.optionId),
  );

  return choosenOptions?.length || activeQuestionAnswer?.freeTextAnswer
    ? {
        job_opening_slug: jobOpeningSlug,
        slug: testSlug,
        data: {
          question_id: Number(activeQuestionId),
          selected_question_options: choosenOptions,
          free_answer_content:
            activeQuestionAnswer?.freeTextAnswer || undefined,
        },
      }
    : null;
}
